(function(){
  function initPokePlugMenu(section){
    if (!section || section.dataset.ppBuilt === 'true') return;
    var data = window.PP_POKEPLUG_MENU_DATA || { desktop: {megamenu: []}, mobile: {sections: []} };
    section.dataset.ppBuilt = 'true';
    const desktopData = data.desktop || { megamenu: [] };
    const mobileData = data.mobile || { sections: [] };
    const desktopRoot = section.querySelector('[data-pp-desktop-root]');
    const MYSTERY_BOX_URL = 'https://pokemonplug.com/pages/mystery-box?_pos=1&_psq=mystery&_ss=e&_v=1.0';
    const mobileRoot = section.querySelector('[data-pp-mobile-root]');
    if (!desktopRoot || !mobileRoot) return;
      const text = value => (value == null ? '' : String(value));

      function esc(str) {
        return text(str).replace(/[&<>"']/g, c => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
      }

      function stripHTML(str) {
        return text(str).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      }

      function isGenericTitle(title) {
        const t = stripHTML(title).toLowerCase();
        return !t || t === 'menu item' || t.includes('submenu item') || t.startsWith('copy of') || t === 'undefined';
      }

      function getUrl(setting = {}) {
        const url = setting.url || {};
        if (url.link) return url.link;
        if (url.collection && url.collection.handle) return `/collections/${url.collection.handle}`;
        if (setting.collection && setting.collection.handle) return `/collections/${setting.collection.handle}`;
        if (url.product && url.product.handle) return `/products/${url.product.handle}`;
        if (url.page && url.page.handle) return `/pages/${url.page.handle}`;
        if (setting.page && setting.page.handle) return `/pages/${setting.page.handle}`;
        if (setting.link) return setting.link;
        return '#';
      }

      function getTitle(item = {}) {
        const s = item.setting || {};
        if (s.title && !isGenericTitle(s.title)) return stripHTML(s.title);
        if (s.collection && s.collection.title) return stripHTML(s.collection.title);
        if (s.url && s.url.collection && s.url.collection.title) return stripHTML(s.url.collection.title);
        if (s.page && s.page.title) return stripHTML(s.page.title);
        if (s.url && s.url.page && s.url.page.title) return stripHTML(s.url.page.title);
        return 'Menu item';
      }

      function getImage(item = {}) {
        const s = item.setting || {};
        if (s.image) return s.image;
        if (s.imgswap_after) return s.imgswap_after;
        if (s.collection && s.collection.image && (s.collection.image.url || s.collection.image.src)) return s.collection.image.url || s.collection.image.src;
        if (s.url && s.url.collection && s.url.collection.image && (s.url.collection.image.url || s.url.collection.image.src)) return s.url.collection.image.url || s.url.collection.image.src;
        return '';
      }

      function isHidden(item = {}) {
        const s = item.setting || {};
        return !!(item.hide || item.hidden_desktop || item.hidden_mobile || s.hidden_desktop || s.hidden_mobile || s.hide);
      }

      function editorReadConfig() {
        var node = section.querySelector('[data-pp-editor-menu]');
        if (!node) return null;
        try { return JSON.parse(node.textContent || '{}'); }
        catch (e) { console.warn('PokePlug menu editor JSON parse failed', e); return null; }
      }

      function editorVisible(block, mobile) {
        if (!block) return false;
        if (mobile) return block.show_mobile !== false;
        return block.show_desktop !== false;
      }

      function editorKey(block) {
        return (block && block.key ? String(block.key) : '').trim();
      }

      function editorUrl(block) {
        var u = block && block.link_url ? String(block.link_url).trim() : '#';
        return u || '#';
      }

      function editorAttrs(block) {
        return block && block.open_new_tab ? ' target="_blank" rel="noopener noreferrer"' : '';
      }

      var ppLegacyImageIndexCache = null;
      function normalizeLookup(value) {
        return stripHTML(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      }

      function buildLegacyImageIndex() {
        if (ppLegacyImageIndexCache) return ppLegacyImageIndexCache;
        var byTitle = {};
        var byTitleUrl = {};
        function remember(item) {
          if (!item || isHidden(item)) return;
          var title = getTitle(item);
          var url = getUrl(item.setting || {});
          var image = getImage(item);
          var keyTitle = normalizeLookup(title);
          var keyCombo = keyTitle + '|' + normalizeLookup(url);
          if (image) {
            if (keyTitle && !byTitle[keyTitle]) byTitle[keyTitle] = image;
            if (keyCombo && !byTitleUrl[keyCombo]) byTitleUrl[keyCombo] = image;
          }
          (item.menus || []).forEach(remember);
        }
        (desktopData.megamenu || []).forEach(remember);
        ppLegacyImageIndexCache = { byTitle: byTitle, byTitleUrl: byTitleUrl };
        return ppLegacyImageIndexCache;
      }

      function editorLegacyImage(block) {
        if (!block) return '';
        if (block.image_url) return block.image_url;
        var index = buildLegacyImageIndex();
        var titleKey = normalizeLookup(block.title);
        var comboKey = titleKey + '|' + normalizeLookup(block.link_url);
        return index.byTitleUrl[comboKey] || index.byTitle[titleKey] || '';
      }

      function editorBlocks(config, type, mobile) {
        return (config.blocks || []).filter(function(b){ return b && b.type === type && editorVisible(b, mobile); });
      }

      function editorChildren(config, parentKey, mobile) {
        return (config.blocks || []).filter(function(b){
          return b && b.type !== 'root_item' && editorVisible(b, mobile) && String(b.parent_key || '').trim() === String(parentKey || '').trim();
        });
      }

      function editorCardHTML(block) {
        var title = block.title || 'Menu item';
        var image = editorLegacyImage(block) || '';
        var html = block.item_type === 'html' && block.html_content ? String(block.html_content) : '';
        if (html) return '<div class="pp-menu-card pp-custom-html">' + html + '</div>';
        return '<a class="pp-menu-card" href="' + esc(editorUrl(block)) + '"' + editorAttrs(block) + '>' +
          (image ? '<span class="pp-card-image-wrap"><img class="pp-card-image" src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy"></span>' : '') +
          '<span>' + esc(title) + '</span></a>';
      }

      function editorTextLinkHTML(block) {
        if (block.item_type === 'html' && block.html_content) return '<div class="pp-text-link pp-custom-html">' + block.html_content + '</div>';
        return '<a class="pp-text-link" href="' + esc(editorUrl(block)) + '"' + editorAttrs(block) + '>' + esc(block.title || 'Menu item') + '</a>';
      }

      function editorBuildGrid(config, root) {
        var kids = editorChildren(config, editorKey(root), false);
        return '<div class="pp-mega-panel pp-panel-grid" role="menu"><div class="pp-panel-label">' + esc(root.title || '') + '</div><div class="pp-panel-content pp-panel-content-full"><div class="pp-mega-logo-grid">' + kids.map(function(k){
          return (k.item_type === 'link' && !editorLegacyImage(k)) ? editorTextLinkHTML(k) : editorCardHTML(k);
        }).join('') + '</div></div></div>';
      }

      function editorBuildTabbed(config, root) {
        var rootKey = editorKey(root);
        var tabs = editorChildren(config, rootKey, false).filter(function(b){ return b.item_type === 'tab' || editorChildren(config, editorKey(b), false).length; });
        if (!tabs.length) tabs = editorChildren(config, rootKey, false);
        var tabsHTML = tabs.map(function(tab, i){
          var img = editorLegacyImage(tab) ? '<img class="pp-tab-img" src="' + esc(editorLegacyImage(tab)) + '" alt="' + esc(tab.title || '') + '" loading="lazy">' : '<span></span>';
          var badge = tab.badge_text ? '<em class="pp-side-badge">' + esc(tab.badge_text) + '</em>' : '';
          var hasKids = editorChildren(config, editorKey(tab), false).length > 0;
          return '<button type="button" class="pp-tab-button ' + (i === 0 ? 'pp-active' : '') + '" data-pp-tab="' + i + '">' + img + '<span class="pp-tab-title">' + esc(tab.title || 'Tab') + badge + '</span><span class="pp-tab-arrow">' + (hasKids ? '›' : '') + '</span></button>';
        }).join('');
        var panes = tabs.map(function(tab, i){
          var items = editorChildren(config, editorKey(tab), false);
          if (!items.length) items = [tab];
          return '<div class="pp-pane" data-pp-pane="' + i + '" style="' + (i === 0 ? '' : 'display:none') + '"><div class="pp-content-grid">' + items.map(function(k){ return (editorLegacyImage(k) || k.item_type === 'card') ? editorCardHTML(k) : editorTextLinkHTML(k); }).join('') + '</div></div>';
        }).join('');
        return '<div class="pp-mega-panel pp-panel-tabbed" role="menu"><div class="pp-panel-label">' + esc(root.title || '') + '</div><div class="pp-panel-inner"><div class="pp-panel-sidebar">' + tabsHTML + '</div><div class="pp-panel-content">' + panes + '</div></div></div>';
      }

      function editorBuildSupplies(config, root) {
        var rootKey = editorKey(root);
        var side = editorChildren(config, rootKey, false);
        var firstIndex = side.findIndex(function(s){ return editorChildren(config, editorKey(s), false).length > 0; });
        if (firstIndex < 0) firstIndex = 0;
        var sideHTML = side.map(function(s, i){
          var hasNested = editorChildren(config, editorKey(s), false).length > 0;
          var sideImg = editorLegacyImage(s);
          var img = sideImg ? '<img src="' + esc(sideImg) + '" alt="' + esc(s.title || '') + '" loading="lazy">' : '';
          return '<a class="pp-supply-side-card' + (i === firstIndex && hasNested ? ' pp-active' : '') + '" href="' + esc(editorUrl(s)) + '"' + editorAttrs(s) + (hasNested ? ' data-pp-supply-tab="' + i + '"' : '') + '>' + img + '<span>' + esc(s.title || '') + '</span><b>' + (hasNested ? '›' : '') + '</b></a>';
        }).join('');
        var panes = side.map(function(s, i){
          var items = editorChildren(config, editorKey(s), false);
          if (!items.length) return '';
          return '<div class="pp-supply-pane" data-pp-supply-pane="' + i + '" style="' + (i === firstIndex ? '' : 'display:none') + '"><a class="pp-red-link" href="' + esc(editorUrl(s)) + '">' + esc(s.title || '') + '</a>' + items.map(editorTextLinkHTML).join('') + '<a class="pp-view-all" href="' + esc(editorUrl(s)) + '">VIEW ALL</a></div>';
        }).join('');
        return '<div class="pp-mega-panel pp-panel-supplies" role="menu"><div class="pp-panel-label">' + esc(root.title || '') + '</div><div class="pp-supplies-layout"><div class="pp-supplies-side">' + sideHTML + '</div><div class="pp-supplies-links">' + panes + '</div></div></div>';
      }

      function editorBuildAbout(config, root) {
        var blocks = editorChildren(config, editorKey(root), false);
        var info = blocks.find(function(b){ return b.type === 'about_content' && b.item_type === 'html'; });
        var form = blocks.find(function(b){ return b.type === 'about_content' && b.item_type === 'contact'; });
        var map = blocks.find(function(b){ return b.type === 'about_content' && b.item_type === 'map'; });
        var formHTML = form && form.show_contact_form !== false ? '<div class="pp-about-form"><h4>Contact us via e-mail</h4><form method="post" action="/contact#contact_form"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input name="contact[name]" placeholder="Name"><input name="contact[email]" type="email" placeholder="Email"><textarea name="contact[body]" placeholder="Message..."></textarea><button type="submit">Send</button></form></div>' : '';
        var mapHTML = map && map.map_embed ? map.map_embed : '';
        return '<div class="pp-mega-panel pp-panel-about" role="menu"><div class="pp-panel-label">' + esc(root.title || '') + '</div><div class="pp-about-layout"><div class="pp-about-store">' + (info && info.html_content ? info.html_content : '') + '</div>' + formHTML + '<div class="pp-about-map">' + mapHTML + '</div></div></div>';
      }

      function findLegacyRootForEditor(root) {
        if (!root) return null;
        var wantedTitle = normalizeLookup(root.title || '');
        var wantedUrl = normalizeLookup(editorUrl(root));
        var roots = (desktopData.megamenu || []).filter(function(item){ return item && !isHidden(item); });
        var exactTitle = roots.find(function(item){ return normalizeLookup(getTitle(item)) === wantedTitle; });
        if (exactTitle) return exactTitle;
        var exactUrl = roots.find(function(item){ return normalizeLookup(getUrl(item.setting || {})) === wantedUrl; });
        if (exactUrl) return exactUrl;
        return null;
      }

      function editorPanel(config, root) {
        var type = root.dropdown_type || 'none';

        /* v22: When editor mode is enabled, keep the dropdown body sourced from
           the original Qikify export by default. This preserves the legacy visual
           layout/content exactly while still allowing top-level roots to be edited
           through Shopify. Disable the setting in the theme editor when you want
           child/card blocks to fully control the dropdown body. */
        if (type !== 'none' && config && config.legacyDropdownContent !== false) {
          var legacyRoot = findLegacyRootForEditor(root);
          if (legacyRoot && hasChildren(legacyRoot)) return buildPanel(legacyRoot);
        }

        if (type === 'grid') return editorBuildGrid(config, root);
        if (type === 'tabbed') return editorBuildTabbed(config, root);
        if (type === 'supplies') return editorBuildSupplies(config, root);
        if (type === 'about') return editorBuildAbout(config, root);
        return '';
      }

      function editorAttachInteractions() {
        section.querySelectorAll('.pp-panel-tabbed').forEach(function(panel){
          var tabs = panel.querySelectorAll('[data-pp-tab]');
          var panes = panel.querySelectorAll('[data-pp-pane]');
          tabs.forEach(function(tab){
            var activate = function(){
              var idx = tab.getAttribute('data-pp-tab');
              tabs.forEach(function(t){ t.classList.toggle('pp-active', t === tab); });
              panes.forEach(function(p){ p.style.display = p.getAttribute('data-pp-pane') === idx ? '' : 'none'; });
            };
            tab.addEventListener('mouseenter', activate); tab.addEventListener('focus', activate); tab.addEventListener('click', activate);
          });
        });
        section.querySelectorAll('.pp-panel-supplies').forEach(function(panel){
          var tabs = panel.querySelectorAll('[data-pp-supply-tab]');
          var panes = panel.querySelectorAll('[data-pp-supply-pane]');
          tabs.forEach(function(tab){
            var activate = function(){
              var idx = tab.getAttribute('data-pp-supply-tab');
              tabs.forEach(function(t){ t.classList.toggle('pp-active', t === tab); });
              panes.forEach(function(p){ p.style.display = p.getAttribute('data-pp-supply-pane') === idx ? '' : 'none'; });
            };
            tab.addEventListener('mouseenter', activate); tab.addEventListener('focus', activate);
          });
        });
      }

      function editorBuildDesktop(config) {
        var roots = editorBlocks(config, 'root_item', false).filter(function(r){ return editorKey(r); });
        var rows = { '1': [], '2': [] };
        roots.forEach(function(r){ (rows[String(r.row || '1')] || rows['1']).push(r); });
        function rootHTML(root){
          var hasPanel = root.dropdown_type && root.dropdown_type !== 'none';
          var badge = root.badge_text ? '<span class="pp-badge">' + esc(root.badge_text) + '</span>' : '';
          var caret = hasPanel && root.show_caret !== false ? '<span class="pp-caret">⌄</span>' : '';
          return '<div class="pp-root-item" data-pp-root-key="' + esc(editorKey(root)) + '">' + badge + '<a class="pp-root-link" href="' + esc(editorUrl(root)) + '"' + editorAttrs(root) + '>' + esc(root.title || 'Menu') + caret + '</a>' + (hasPanel ? editorPanel(config, root) : '') + '</div>';
        }
        desktopRoot.innerHTML = '<div class="pp-root-row pp-root-row-1">' + rows['1'].map(rootHTML).join('') + '</div>' + (rows['2'].length ? '<div class="pp-root-row pp-root-row-2">' + rows['2'].map(rootHTML).join('') + '</div>' : '');
        editorAttachInteractions();
      }

      function editorBuildMobile(config) {
        var html = '';
        if (config.mobileSearch) html += '<div class="pp-drawer-section"><form action="/search" method="get" role="search"><input class="pp-mobile-search" type="search" name="q" placeholder="Search"></form></div>';
        if (config.mobileAccount) html += '<div class="pp-drawer-section"><p class="pp-drawer-title">Account</p><div class="pp-mobile-account"><a href="/account/login">Login</a><a href="/account/register">Register</a><a href="/account">My Account</a></div></div>';
        var roots = editorBlocks(config, 'root_item', true).filter(function(r){ return editorKey(r); });
        html += '<div class="pp-drawer-section"><p class="pp-drawer-title">' + esc(config.mobileCollectionsTitle || 'Menu') + '</p>';
        roots.forEach(function(root){
          var kids = editorChildren(config, editorKey(root), true);
          if (kids.length) {
            html += '<details class="pp-mobile-details"><summary>' + esc(root.title || 'Menu') + '</summary><div class="pp-mobile-nested">';
            kids.forEach(function(k){ html += '<a class="pp-mobile-link" href="' + esc(editorUrl(k)) + '"' + editorAttrs(k) + '>' + esc(k.title || 'Menu item') + '</a>'; });
            html += '</div></details>';
          } else {
            html += '<a class="pp-mobile-link" href="' + esc(editorUrl(root)) + '"' + editorAttrs(root) + '>' + esc(root.title || 'Menu') + '</a>';
          }
        });
        html += '</div>';
        mobileRoot.innerHTML = html;
      }

      function editorSetupDrawerControls() {
        const openBtns = section.querySelectorAll('[data-pp-open-mobile]');
        const closeBtns = section.querySelectorAll('[data-pp-close-mobile]');
        openBtns.forEach(btn => btn.addEventListener('click', () => { section.classList.add('pp-mobile-open'); document.documentElement.style.overflow = 'hidden'; }));
        closeBtns.forEach(btn => btn.addEventListener('click', () => { section.classList.remove('pp-mobile-open'); document.documentElement.style.overflow = ''; }));
        document.addEventListener('keydown', e => { if (e.key === 'Escape') { section.classList.remove('pp-mobile-open'); document.documentElement.style.overflow = ''; } });
      }

      var editorConfig = editorReadConfig();
      if (editorConfig && editorConfig.enabled && (editorConfig.blocks || []).some(function(b){ return b.type === 'root_item'; })) {
        editorBuildDesktop(editorConfig);
        editorBuildMobile(editorConfig);
        editorSetupDrawerControls();
        return;
      }

      function isForcedDropdownRoot(item = {}) {
        const title = getTitle(item);
        return title === 'Card Catalog' || title === 'Sealed Product (In Stock)' || title === 'Card Supplies & More' || title === 'About Us & Contact';
      }

      function hasChildren(item = {}) {
        const children = Array.isArray(item.menus) && item.menus.some(x => x && !isHidden(x));
        if (!children) return false;
        // Qikify exports some active dropdown roots with hide_submenu=true even though
        // the live menu still opens them. Force those four live desktop dropdowns on.
        if (isForcedDropdownRoot(item)) return true;
        return !item.hide_submenu;
      }

      function flattenRenderable(items = [], depth = 0, maxDepth = 7) {
        const out = [];
        if (depth > maxDepth) return out;
        items.forEach(item => {
          if (!item || isHidden(item)) return;
          const s = item.setting || {};
          const children = Array.isArray(item.menus) ? item.menus.filter(x => x && !isHidden(x)) : [];
          const directTitle = getTitle(item);
          const url = getUrl(s);
          const image = getImage(item);
          if (s.item_layout !== 'block' && s.item_layout !== 'html' && s.item_layout !== 'contact_form' && s.item_layout !== 'maps') {
            if (s.item_display !== false || image || url !== '#' || children.length) {
              out.push({ item, title: directTitle, url, image, children });
            }
          }
          if (children.length) {
            out.push(...flattenRenderable(children, depth + 1, maxDepth));
          }
        });
        return out;
      }

      function cardHTML(entry, feature = false) {
        if (entry && entry.title === 'Mystery Boxes') entry.url = MYSTERY_BOX_URL;
        const cls = feature ? 'pp-feature-image' : 'pp-card-image';
        const image = entry.image ? `<span class="pp-card-image-wrap"><img class="${cls}" src="${esc(entry.image)}" alt="${esc(entry.title)}" loading="lazy"></span>` : '';
        return `<a class="pp-menu-card" href="${esc(entry.url)}">${image}<span>${esc(entry.title)}</span></a>`;
      }

      function textLinkHTML(entry) {
        if (entry && entry.title === 'Mystery Boxes') entry.url = MYSTERY_BOX_URL;
        return `<a class="pp-text-link" href="${esc(entry.url)}">${esc(entry.title)}</a>`;
      }

      function renderContentFor(item) {
        const immediate = (item.menus || []).filter(x => x && !isHidden(x) && (x.setting || {}).item_layout !== 'block');
        const immediateEntries = immediate.map(child => ({
          item: child,
          title: getTitle(child),
          url: getUrl(child.setting || {}),
          image: getImage(child),
          children: child.menus || []
        })).filter(e => e.title && e.title !== 'Menu item');

        const deepEntries = flattenRenderable(item.menus || []);
        const entries = immediateEntries.length ? immediateEntries : deepEntries;
        const imageEntries = entries.filter(e => e.image);
        const textEntries = entries.filter(e => !e.image);

        if (imageEntries.length >= 4) {
          return `<div class="pp-content-grid">${imageEntries.map(e => cardHTML(e)).join('')}${textEntries.slice(0, 12).map(e => textLinkHTML(e)).join('')}</div>`;
        }

        if (imageEntries.length > 0 && textEntries.length > 0) {
          return `<div class="pp-content-grid pp-content-grid-mixed">${imageEntries.map(e => cardHTML(e)).join('')}${textEntries.map(e => textLinkHTML(e)).join('')}</div>`;
        }

        if (entries.length > 0) {
          return `<div class="pp-link-grid">${entries.map(e => textLinkHTML(e)).join('')}</div>`;
        }

        const self = {
          title: getTitle(item),
          url: getUrl(item.setting || {}),
          image: getImage(item),
        };
        return self.image ? cardHTML(self, true) : textLinkHTML(self);
      }

      function buildTabbedPanel(rootItem) {
        const children = (rootItem.menus || []).filter(x => x && !isHidden(x));
        if (!children.length) return '';
        const rootTitle = getTitle(rootItem);
        const tabs = children.map((child, i) => {
          const title = getTitle(child);
          const img = getImage(child);
          const imgHTML = img ? `<img class="pp-tab-img" src="${esc(img)}" alt="${esc(title)}" loading="lazy">` : `<span></span>`;
          const arrow = (child.menus && child.menus.length) ? '›' : '';
          const badge = child.setting && child.setting.badge && child.setting.badge_text ? `<em class="pp-side-badge">${esc(child.setting.badge_text)}</em>` : '';
          return `<button type="button" class="pp-tab-button ${i === 0 ? 'pp-active' : ''}" data-pp-tab="${i}">
            ${imgHTML}<span class="pp-tab-title">${esc(title)}${badge}</span><span class="pp-tab-arrow">${arrow}</span>
          </button>`;
        }).join('');
        const panes = children.map((child, i) => (
          `<div class="pp-pane" data-pp-pane="${i}" style="${i === 0 ? '' : 'display:none'}">${renderContentFor(child)}</div>`
        )).join('');
        return `<div class="pp-mega-panel pp-panel-tabbed" role="menu">
          <div class="pp-panel-label">${esc(rootTitle)}</div>
          <div class="pp-panel-inner"><div class="pp-panel-sidebar">${tabs}</div><div class="pp-panel-content">${panes}</div></div>
        </div>`;
      }

      function buildMegaGridPanel(rootItem) {
        const rootTitle = getTitle(rootItem);
        const children = (rootItem.menus || []).filter(x => x && !isHidden(x));
        const cards = [];
        const textGroups = [];
        children.forEach(child => {
          const childEntry = { item: child, title: getTitle(child), url: getUrl(child.setting || {}), image: getImage(child), children: child.menus || [] };
          if (childEntry.image) cards.push(childEntry);
          const nested = flattenRenderable(child.menus || []).filter(e => !e.image);
          if (nested.length) textGroups.push(`<div class="pp-menu-list-group"><a class="pp-group-title" href="${esc(childEntry.url)}">${esc(childEntry.title)}</a>${nested.map(e => textLinkHTML(e)).join('')}</div>`);
        });
        return `<div class="pp-mega-panel pp-panel-grid" role="menu">
          <div class="pp-panel-label">${esc(rootTitle)}</div>
          <div class="pp-panel-content pp-panel-content-full">
            <div class="pp-mega-logo-grid">${cards.map(e => cardHTML(e)).join('')}</div>
            ${textGroups.length ? `<div class="pp-menu-text-groups">${textGroups.join('')}</div>` : ''}
          </div>
        </div>`;
      }

      function nestedLinksFor(child) {
        const nested = flattenRenderable(child.menus || []).filter(e => e.url !== '#');
        if (nested.length) return nested.map(e => textLinkHTML(e)).join('');
        const self = { title: getTitle(child), url: getUrl(child.setting || {}), image: getImage(child), children: [] };
        return textLinkHTML(self);
      }

      function buildSuppliesPanel(rootItem) {
        const rootTitle = getTitle(rootItem);
        const children = (rootItem.menus || []).filter(x => x && !isHidden(x));
        const firstWithChildren = children.findIndex(child => child.menus && child.menus.some(x => x && !isHidden(x)));
        const activeIndex = firstWithChildren >= 0 ? firstWithChildren : 0;
        const sideCards = children.map((child, i) => {
          const img = getImage(child);
          const title = getTitle(child);
          const url = getUrl(child.setting || {});
          const hasNested = !!(child.menus && child.menus.some(x => x && !isHidden(x)));
          const arrow = hasNested ? '›' : '';
          const tabAttr = hasNested ? ` data-pp-supply-tab="${i}"` : '';
          const active = i === activeIndex && hasNested ? ' pp-active' : '';
          return `<a class="pp-supply-side-card${active}" href="${esc(url)}"${tabAttr}>${img ? `<img src="${esc(img)}" alt="${esc(title)}" loading="lazy">` : ''}<span>${esc(title)}</span><b>${arrow}</b></a>`;
        }).join('');
        const panes = children.map((child, i) => {
          const hasNested = !!(child.menus && child.menus.some(x => x && !isHidden(x)));
          if (!hasNested) return '';
          const childUrl = getUrl(child.setting || {});
          const childTitle = getTitle(child);
          const heading = i === 0 ? 'Browse Card Accessories & Supplies' : childTitle;
          const viewAllHref = childUrl && childUrl !== '#' ? childUrl : '/collections/card-accessories';
          return `<div class="pp-supply-pane" data-pp-supply-pane="${i}" style="${i === activeIndex ? '' : 'display:none'}">
            <a class="pp-red-link" href="${esc(viewAllHref)}">${esc(heading)}</a>
            ${nestedLinksFor(child)}
            <a class="pp-view-all" href="${esc(viewAllHref)}">VIEW ALL</a>
          </div>`;
        }).join('');
        return `<div class="pp-mega-panel pp-panel-supplies" role="menu">
          <div class="pp-panel-label">${esc(rootTitle)}</div>
          <div class="pp-supplies-layout">
            <div class="pp-supplies-side">${sideCards}</div>
            <div class="pp-supplies-links">${panes}</div>
          </div>
        </div>`;
      }

      function buildAboutPanel(rootItem) {
        const rootTitle = getTitle(rootItem);
        const kids = (rootItem.menus || []).filter(x => x && !isHidden(x));
        const htmlItem = kids.find(x => (x.setting || {}).item_layout === 'html');
        const formItem = kids.find(x => (x.setting || {}).item_layout === 'contact_form');
        const mapItem = kids.find(x => (x.setting || {}).item_layout === 'maps');
        const customHtml = htmlItem && htmlItem.setting ? htmlItem.setting.custom_html || '' : '';
        const formTitle = formItem ? getTitle(formItem) : 'Contact us via e-mail';
        const mapHtml = mapItem && mapItem.setting ? mapItem.setting.map_iframe || '' : '';
        return `<div class="pp-mega-panel pp-panel-about" role="menu">
          <div class="pp-panel-label">${esc(rootTitle)}</div>
          <div class="pp-about-layout">
            <div class="pp-about-store">${customHtml}</div>
            <div class="pp-about-form"><h4>${esc(formTitle)}</h4><form action="/contact#contact_form" method="post"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input name="contact[name]" placeholder="Name"><input name="contact[email]" type="email" placeholder="Email"><textarea name="contact[body]" placeholder="Message..."></textarea><button type="submit">Send</button></form></div>
            <div class="pp-about-map">${mapHtml}</div>
          </div>
        </div>`;
      }

      function buildPanel(rootItem) {
        const title = getTitle(rootItem);
        if (!hasChildren(rootItem)) return '';
        if (title === 'Card Catalog') return buildTabbedPanel(rootItem);
        if (title === 'Card Supplies & More') return buildSuppliesPanel(rootItem);
        if (title === 'About Us & Contact') return buildAboutPanel(rootItem);
        return buildMegaGridPanel(rootItem);
      }

      function renderSocialRoot(root) {
        const s = root.setting || {};
        const fb = s.facebook_link ? `<a class="pp-root-link pp-social-root" href="${esc(s.facebook_link)}" target="_blank" rel="noopener" aria-label="Facebook">f</a>` : `<a class="pp-root-link pp-social-root" href="https://www.facebook.com/PokemonPlug" target="_blank" rel="noopener" aria-label="Facebook">f</a>`;
        const ig = s.instagram_link ? `<a class="pp-root-link pp-social-root" href="${esc(s.instagram_link)}" target="_blank" rel="noopener" aria-label="Instagram">◎</a>` : `<a class="pp-root-link pp-social-root" href="https://www.instagram.com/pokemonplug" target="_blank" rel="noopener" aria-label="Instagram">◎</a>`;
        return `<div class="pp-root-item pp-root-socials">${fb}${ig}</div>`;
      }

      function buildDesktop() {
        const activeDesktopTitles = [
          'NEW IN STOCK',
          'Card Catalog',
          'Sealed Product (In Stock)',
          'Card Supplies & More',
          'Mystery Boxes',
          'Preorders - Reserve Now!',
          'SUBSCRIBER EXCLUSIVE',
          'About Us & Contact',
          'News',
          'Follow Our Social!'
        ];

        const allRoots = (desktopData.megamenu || []).filter(x => x && !isHidden(x));
        const roots = activeDesktopTitles.map(title => allRoots.find(x => getTitle(x) === title)).filter(Boolean);

        function renderRootItem(root) {
          const s = root.setting || {};
          const title = getTitle(root);
          if (s.item_layout === 'social' || title === 'Follow Our Social!') return renderSocialRoot(root);
          let url = getUrl(s);
          if (title === 'Mystery Boxes') url = MYSTERY_BOX_URL;
          const badge = s.badge && s.badge_text ? `<span class="pp-badge">${esc(s.badge_text)}</span>` : '';
          const caret = hasChildren(root) ? `<span class="pp-caret">⌄</span>` : '';
          const panel = hasChildren(root) ? buildPanel(root) : '';
          return `<div class="pp-root-item" data-pp-root-title="${esc(title)}">
            ${badge}<a class="pp-root-link" href="${esc(url)}">${esc(title)}${caret}</a>${panel}
          </div>`;
        }

        const rowBreakIndex = roots.findIndex(root => getTitle(root) === 'SUBSCRIBER EXCLUSIVE');
        const rowOne = rowBreakIndex > -1 ? roots.slice(0, rowBreakIndex) : roots;
        const rowTwo = rowBreakIndex > -1 ? roots.slice(rowBreakIndex) : [];
        desktopRoot.innerHTML = `<div class="pp-root-row pp-root-row-1">${rowOne.map(renderRootItem).join('')}</div>${rowTwo.length ? `<div class="pp-root-row pp-root-row-2">${rowTwo.map(renderRootItem).join('')}</div>` : ''}`;

        section.querySelectorAll('.pp-panel-tabbed').forEach(panel => {
          const tabs = panel.querySelectorAll('[data-pp-tab]');
          const panes = panel.querySelectorAll('[data-pp-pane]');
          tabs.forEach(tab => {
            const activate = () => {
              const idx = tab.getAttribute('data-pp-tab');
              tabs.forEach(t => t.classList.toggle('pp-active', t === tab));
              panes.forEach(p => p.style.display = p.getAttribute('data-pp-pane') === idx ? '' : 'none');
            };
            tab.addEventListener('mouseenter', activate);
            tab.addEventListener('focus', activate);
            tab.addEventListener('click', activate);
          });
        });

        section.querySelectorAll('.pp-panel-supplies').forEach(panel => {
          const tabs = panel.querySelectorAll('[data-pp-supply-tab]');
          const panes = panel.querySelectorAll('[data-pp-supply-pane]');
          tabs.forEach(tab => {
            const activate = () => {
              const idx = tab.getAttribute('data-pp-supply-tab');
              tabs.forEach(t => t.classList.toggle('pp-active', t === tab));
              panes.forEach(p => p.style.display = p.getAttribute('data-pp-supply-pane') === idx ? '' : 'none');
            };
            tab.addEventListener('mouseenter', activate);
            tab.addEventListener('focus', activate);
          });
        });

        /* v16: normal hover behavior restored.
           No dropdown lock/preservation. Hovering a different root item switches immediately. */
        let closeTimer = null;
        section.querySelectorAll('.pp-root-item').forEach(root => {
          const panel = root.querySelector('.pp-mega-panel');
          if (!panel) return;

          const open = () => {
            window.clearTimeout(closeTimer);
            closeTimer = null;
            section.querySelectorAll('.pp-root-item.pp-open').forEach(item => {
              if (item !== root) item.classList.remove('pp-open');
            });
            root.classList.add('pp-open');
          };

          const scheduleClose = () => {
            window.clearTimeout(closeTimer);
            closeTimer = window.setTimeout(() => {
              root.classList.remove('pp-open');
            }, 120);
          };

          root.addEventListener('mouseenter', open);
          root.addEventListener('focusin', open);
          root.addEventListener('mouseleave', scheduleClose);
          panel.addEventListener('mouseenter', open);
          panel.addEventListener('mouseleave', scheduleClose);
        });

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            section.querySelectorAll('.pp-root-item.pp-open').forEach(item => item.classList.remove('pp-open'));
          }
        });
      }

      function mobileLinkFromBlock(block, nested = false) {
        const s = block.setting || {};
        const title = getTitle(block);
        const url = getUrl(s);
        const kids = (block.blocks || block.menus || []).filter(x => x && !x.hide);
        if (kids.length) {
          return `<details class="pp-mobile-details"${nested ? '' : ''}>
            <summary>${esc(title)}</summary>
            <div class="pp-mobile-nested">${kids.map(k => mobileLinkFromBlock(k, true)).join('')}</div>
          </details>`;
        }
        return `<a class="pp-mobile-link" href="${esc(url)}">${esc(title)}</a>`;
      }

      function buildMobile() {
        const sections = (mobileData.sections || []).filter(s => s && !s.hide);
        const html = sections.map(sec => {
          const setting = sec.setting || {};
          if (sec.type === 'search') {
            const placeholder = setting.placeholder || 'Search';
            return `<div class="pp-drawer-section">
              <form action="/search" method="get" role="search">
                <input class="pp-mobile-search" type="search" name="q" placeholder="${esc(placeholder)}">
              </form>
            </div>`;
          }

          if (sec.type === 'account') {
            return `<div class="pp-drawer-section">
              <p class="pp-drawer-title">Account</p>
              <div class="pp-mobile-account">
                <a href="/account/login">Login</a>
                <a href="/account/register">Register</a>
                <a href="/account">My Account</a>
              </div>
            </div>`;
          }

          if (sec.type === 'collection') {
            const blocks = (sec.blocks || []).filter(b => b && !b.hide);
            if (!blocks.length) return '';
            const title = setting.disable_title ? '' : `<p class="pp-drawer-title">${esc(setting.title || sec.heading || 'Collections')}</p>`;
            return `<div class="pp-drawer-section">
              ${title}
              <div class="pp-mobile-grid">
                ${blocks.map(block => {
                  const item = {
                    title: getTitle(block),
                    url: getUrl(block.setting || {}),
                    image: getImage(block)
                  };
                  return `<a class="pp-mobile-card" href="${esc(item.url)}">
                    ${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : ''}
                    <span>${esc(item.title)}</span>
                  </a>`;
                }).join('')}
              </div>
            </div>`;
          }

          if (sec.type === 'menu') {
            const blocks = (sec.blocks || []).filter(b => b && !b.hide);
            if (!blocks.length) return '';
            const title = setting.disable_title ? '' : `<p class="pp-drawer-title">${esc(setting.title || sec.heading || 'Menu')}</p>`;
            const body = blocks.map(b => mobileLinkFromBlock(b)).join('');
            if (setting.enable_collapse || setting.collapsed_by_default) {
              return `<div class="pp-drawer-section">
                ${title}
                <details class="pp-mobile-details" ${setting.collapsed_by_default ? '' : 'open'}>
                  <summary>${esc(setting.title || sec.heading || 'Menu')}</summary>
                  <div class="pp-mobile-nested">${body}</div>
                </details>
              </div>`;
            }
            return `<div class="pp-drawer-section">${title}${body}</div>`;
          }

          return '';
        }).join('');

        mobileRoot.innerHTML = html;
      }

      buildDesktop();
      buildMobile();

      const openBtns = section.querySelectorAll('[data-pp-open-mobile]');
      const closeBtns = section.querySelectorAll('[data-pp-close-mobile]');
      openBtns.forEach(btn => btn.addEventListener('click', () => {
        section.classList.add('pp-mobile-open');
        document.documentElement.style.overflow = 'hidden';
      }));
      closeBtns.forEach(btn => btn.addEventListener('click', () => {
        section.classList.remove('pp-mobile-open');
        document.documentElement.style.overflow = '';
      }));
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          section.classList.remove('pp-mobile-open');
          document.documentElement.style.overflow = '';
        }
      });

  }
  function initAll(){
    document.querySelectorAll('.pp-native-menu-section').forEach(initPokePlugMenu);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(event){
    if (event && event.target) event.target.querySelectorAll('.pp-native-menu-section').forEach(initPokePlugMenu);
  });
})();